import TransportadoraTelefoneService from "@/services/TransportadoraTelefoneService";

export const transportadoraTelefone = {
  namespaced: true,
  state: {
    transportadoraTelefone: {},
  },
  actions: {
    getTransportadoraTelefone({ commit }, payload) {
      return TransportadoraTelefoneService.GetTransportadoraTelefone(
        payload
      ).then(
        (transportadoraTelefone) => {
          return Promise.resolve(transportadoraTelefone);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postTransportadoraTelefone({ commit }, payload) {
      return TransportadoraTelefoneService.PostTransportadoraTelefone(
        payload
      ).then(
        (transportadoraTelefone) => {
          return Promise.resolve(transportadoraTelefone);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putTransportadoraTelefone({ commit }, payload) {
      return TransportadoraTelefoneService.PutTransportadoraTelefone(
        payload
      ).then(
        (transportadoraTelefone) => {
          return Promise.resolve(transportadoraTelefone);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteTransportadoraTelefone({ commit }, payload) {
      return TransportadoraTelefoneService.DeleteTransportadoraTelefone(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getTransportadoraTelefoneOData({ commit }, payload) {
      return TransportadoraTelefoneService.GetTransportadoraTelefoneOData(
        payload
      ).then(
        (transportadoraTelefone) => {
          return Promise.resolve(transportadoraTelefone);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default transportadoraTelefone;
